/** Voice selection persistence and transport restart actions. */

export function getAdjacentVoiceIndex(currentIndex, optionCount, direction) {
    if (optionCount < 1) return -1;
    const safeIndex = Math.max(0, Number(currentIndex) || 0);
    const step = direction < 0 ? -1 : 1;
    return (safeIndex + step + optionCount) % optionCount;
}

export function restartVoiceTransport(ctx) {
    if (ctx.isLiveKitActive()) {
        ctx.restartLiveKit();
        return 'livekit';
    }
    if (ctx.isWebRTCActive()) {
        ctx.restartWebRTC();
        return 'webrtc';
    }
    if (ctx.isClassicSessionActive()) {
        ctx.changeClassicVoice();
        return 'classic';
    }
    return 'none';
}

export function interruptVoiceTransport(ctx) {
    if (ctx.isLiveKitActive()) {
        ctx.interruptLiveKit();
        return 'livekit';
    }
    if (ctx.isWebRTCActive()) {
        ctx.interruptWebRTC();
        return 'webrtc';
    }
    if (ctx.isClassicSessionActive()) {
        ctx.interruptClassic();
        return 'classic';
    }
    return 'none';
}

export function scheduleVoiceTransportRestart(state, restart, delayMs = 350) {
    if (state.timeout !== null) clearTimeout(state.timeout);
    state.timeout = setTimeout(function() {
        state.timeout = null;
        restart();
    }, delayMs);
    return state.timeout;
}

export function cancelScheduledVoiceTransportRestart(state) {
    if (state.timeout === null) return false;
    clearTimeout(state.timeout);
    state.timeout = null;
    return true;
}

export function changeVideocallVoice(select, ctx) {
    if (select.prop('disabled')) return false;
    const voice = String(select.val() || '');
    const previousVoice = String(select.attr('data-current-voice') || '');
    const status = select.closest('.modal-videocall-voice-setting').find('.modal-videocall-voice-status');

    if (!voice || voice === previousVoice) return false;

    ctx.onVoiceChangeStarted(voice, previousVoice);
    select.prop('disabled', true);
    status.text('Saving…');

    ctx.persistVoice(voice)
        .done(function(response) {
            if (!response || response.success === false) {
                select.val(previousVoice);
                status.text('Could not change voice.');
                ctx.onVoiceChangeFailed(previousVoice);
                return;
            }

            select.attr('data-current-voice', voice);
            status.text('Voice changed');
            ctx.onVoiceChanged(voice);
        })
        .fail(function() {
            select.val(previousVoice);
            status.text('Could not change voice.');
            ctx.onVoiceChangeFailed(previousVoice);
        })
        .always(function() {
            const keepDisabled = typeof ctx.keepDisabledAfterSave === 'function'
                && ctx.keepDisabledAfterSave();
            select.prop('disabled', Boolean(keepDisabled));
            setTimeout(function() { status.text(''); }, 2200);
        });

    return true;
}
